<template>
  <v-btn
    :id="id"
    :type="type"
    :class="[bindClass, { 'has-extra-content': hasExtraContent }]"
    :width="width"
    :height="hasExtraContent ? '80px' : height"
    :loading="loading"
    :disabled="disabled"
    :to="to"
    :depressed="depressed"
    :readonly="readonly"
    @click.stop="btnClick()"
  >
    <div class="button-content">
      <div v-if="loading" class="message">{{ loadingMessage }}</div>
      <div v-else-if="disabled && !hasSlotContent" class="message">{{ disabledMessage }}</div>
      <div v-else class="message-container">
        <div v-if="header" class="header">{{ header }}</div>
        <div class="body"><slot /></div>
        <div v-if="footer" class="footer">{{ footer }}</div>
      </div>
    </div>
  </v-btn>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'default',
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '52px',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {},
    type: {
      type: String,
      default: 'button',
    },
    depressed: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: '처리중...',
    },
    disabledMessage: {
      type: String,
      default: '비활성화됨',
    },
    header: {
      type: String,
      default: '',
    },
    footer: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      colorSet: {
        default: 'btn--default',
        black: 'btn--black',
        white: 'btn--white',
        green: 'btn--green',
        pink: 'btn--pink',
      },
    }
  },
  computed: {
    colorClass() {
      return this.colorSet[this.color]
    },
    bindClass() {
      const basic = ['basic-button', 'font-size--18']
      return [...basic, this.colorClass, ...this.classes]
    },
    hasExtraContent() {
      return !!(this.header || this.footer)
    },
    hasSlotContent() {
      return !!this.$slots.default
    },
  },
  methods: {
    btnClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

button:disabled,
.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: $gray-fill !important;
  color: $white !important;
}

.basic-button {
  line-height: 1.4;

  &.has-extra-content {
    padding: 12px 16px;
  }

  .button-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .message-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 2px;

      .header {
        font-size: 11px;
        color: #ffffff;
        text-align: center;
        opacity: 0.9;
        padding-bottom: 0px;
        margin-bottom: 0px;
      }

      .body {
        font-size: 20px;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 1.3;
        letter-spacing: -0.3px;
      }

      .footer {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.5);
        text-align: right;
        padding-top: 2px;
      }
    }
  }
}

// 기본 버튼 (header/footer 없을 때)
.basic-button:not(.has-extra-content) {
  padding: 8px 16px;

  .message-container {
    .body {
      padding: 4px 0;
      font-size: 18px;
    }
  }
}

.basic-button {
  &.basic-button--apply {
    .message-container {
      .footer {
        color: #6b85e2;
      }
    }
  }

  .button-content {
    .message-container {
      .header {
        font-size: 11px;
        color: #ffffff;
        text-align: center;
        opacity: 0.9;
        padding-bottom: 2px;
      }

      .body {
        font-size: 20px;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 1.3;
        letter-spacing: -0.3px;
      }

      .footer {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.7);
        text-align: right;
        padding-top: 2px;
      }
    }
  }
}
</style>
